/* eslint-disable simple-import-sort/imports */
import React, { useState } from 'react';
import ChatLists from './ChatLists';
import ChatContainer from './ChatContainer';

interface Chat {
  id: number;
  name: string;
  lastMessage: string;
  time: string;
  picture: string;
  statusId: string;
}

const ClinicChat = () => {
  const [selectedChat, setSelectedChat] = useState<Chat | undefined>(undefined);
  const [showChat, setShowChat] = useState(false);

  return (
    <>
      <div
        className="grid bg-gray-100 lg:grid-cols-[25%_75%]"
        style={{ height: 'calc(-16px + 100vh)' }}
      >
        {/* Sidebar */}
        <ChatLists
          showChat={showChat}
          setShowChat={setShowChat}
          selectedChat={selectedChat}
          setSelectedChat={setSelectedChat}
        />

        {/* Chat Window */}
        <ChatContainer
          showChat={showChat}
          setShowChat={setShowChat}
          selectedChat={selectedChat}
        />
      </div>
    </>
  );
};

export default ClinicChat;
